import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {User} from '@app/models/vcr-entity/user';
import {RemoteUserAdditionalInfoStateModel} from '@app/state/remote-users.state';
import {AccessType, ConnectionStatus} from '@app/modules/shared/data/constants';

export class RemoteParticipantsInfo {
  public students: RemoteParticipantInfo [];
  public teachers: RemoteParticipantInfo [];
  public supports: RemoteParticipantInfo [];
  public observers: RemoteParticipantInfo [];

  constructor() {
    this.students = [];
    this.teachers = [];
    this.supports = [];
    this.observers = [];
  }

  public getAll(): RemoteParticipantInfo[] {
    return this.students.concat(this.teachers, this.supports, this.observers);
  }
  public getUser(id: number): RemoteParticipantInfo | undefined {
    return this.students.concat(this.teachers, this.supports, this.observers).find(value => value.id === id);
  }

  public changeAccessType(userId: number, accessType: AccessType) {
    const result: {index: number; user: RemoteParticipantInfo} = this.findUser(userId);
    switch (result.user.accessType) {
      case AccessType.TEACHER:
        this.teachers.splice(result.index, 1);
        break;
      case AccessType.SUPPORT:
        this.supports.splice(result.index, 1);
        break;
      case AccessType.OBSERVER:
        this.observers.splice(result.index, 1);
        break;
      case AccessType.STUDENT:
        this.students.splice(result.index, 1);
        break;
    }

    result.user.accessType = accessType;
    switch (accessType) {
      case AccessType.TEACHER:
        this.teachers.push(result.user);
        break;
      case AccessType.SUPPORT:
        this.supports.push(result.user);
        break;
      case AccessType.OBSERVER:
        this.observers.push(result.user);
        break;
      case AccessType.STUDENT:
        this.students.push(result.user);
        break;
    }
  }

  public getAllUsersExceptTeachers(): RemoteParticipantInfo[] {
    return this.students.concat(this.supports, this.observers);
  }

  public getAllTeachers(): RemoteParticipantInfo[] {
    return this.teachers;
  }

  public addUser(user: User, info: RemoteUserAdditionalInfoStateModel): void {
    const userFullInfo = new RemoteParticipantInfo(user, info);
    switch (userFullInfo.accessType) {
      case AccessType.STUDENT: {
        this.students = [...this.students, userFullInfo];
        break;
      }
      case AccessType.TEACHER: {
        this.teachers = [...this.teachers, userFullInfo];
        break;
      }
      case AccessType.SUPPORT: {
        this.supports = [...this.supports, userFullInfo];
        break;
      }
      case AccessType.OBSERVER: {
        this.observers = [...this.observers, userFullInfo];
        break;
      }
    }
  }

  public removeUser(userId: number, accessType: AccessType): void {
    switch (accessType) {
      case AccessType.STUDENT: {
        this.students = this.students.filter(user => user.id !== userId);
        break;
      }
      case AccessType.SUPPORT: {
        this.supports = this.supports.filter(user => user.id !== userId);
        break;
      }
      case AccessType.TEACHER: {
        this.teachers = this.teachers.filter(user => user.id !== userId);
        break;
      }
      case AccessType.OBSERVER: {
        this.observers = this.observers.filter(user => user.id !== userId);
        break;
      }

    }

  }
  public isEvenOneUserOnline(role: AccessType): boolean {
    let remoteUsers: RemoteParticipantInfo[];
    switch (role) {
      case AccessType.STUDENT:
        remoteUsers = this.students;
        break;
      case AccessType.SUPPORT:
        remoteUsers = this.supports;
        break;
      case AccessType.TEACHER:
        remoteUsers = this.teachers;
        break;
      case AccessType.OBSERVER:
        remoteUsers = this.observers;
        break;
    }

    for (const remoteUser of remoteUsers) {
      if (remoteUser.additionalInfo.roomConnectionStatus === ConnectionStatus.ONLINE) {
        return true;
      }
    }

    return false;
  }

  private findUser(id: number): {index: number; user: RemoteParticipantInfo} {
    for (let i = 0; i < this.teachers.length; ++i) {
      if (this.teachers[i].id === id) {
        return {index: i, user: this.teachers[i]};
      }
    }
    for (let i = 0; i < this.supports.length; ++i) {
      if (this.supports[i].id === id) {
        return {index: i, user: this.supports[i]};
      }
    }
    for (let i = 0; i < this.observers.length; ++i) {
      if (this.observers[i].id === id) {
        return {index: i, user: this.observers[i]};
      }
    }
    for (let i = 0; i < this.students.length; ++i) {
      if (this.students[i].id === id) {
        return {index: i, user: this.students[i]};
      }
    }
    return undefined;
  }
}


